export const isTagUpdated = (state) => {
    return state.isTagUpdated.updated
  }